import { Flex, Heading, Accordion } from '@chakra-ui/react'
import N25_11_13 from './notes/N25_11_13'
import N25_11_12 from './notes/N25_11_12'
import N25_11_11 from './notes/N25_11_11'
import N25_11_06 from './notes/N25_11_06'
import N25_11_05 from './notes/N25_11_05'
import N25_11_04 from './notes/N25_11_04'
import N25_10_28 from './notes/N25_10_28'
import N25_10_24 from './notes/N25_10_24'
import N25_10_21 from './notes/N25_10_21'
import N25_10_16 from './notes/N25_10_16'
import N25_10_14 from './notes/N25_10_14'
import N25_10_13 from './notes/N25_10_13'
import N25_10_10 from './notes/N25_10_10'
import N25_10_08 from './notes/N25_10_08'
import N25_10_03 from './notes/N25_10_03'
import N25_10_02 from './notes/N25_10_02'
import N25_09_30 from './notes/N25_09_30'
import N25_09_29 from './notes/N25_09_29'
import N25_09_16 from './notes/N25_09_16'
import N25_09_15 from './notes/N25_09_15'

export default function NotesContainer() {
  return (
    <Flex
      w="full"
      flexDir="column"
      p={4}
      gap={2}
      borderLeft="1px solid"
      borderColor="borderColor"
      h="calc(100vh - 63px)"
      overflowY="scroll"
    >
      <Heading size="sm" fontWeight="bold">
        Notas de atualização
      </Heading>
      {/* <Empty
        title="Sem nota de atualização no momento"
        description="Estamos organizando uma maneira de você ficar sempre por dentro das novidades!"
      /> */}
      <Accordion defaultIndex={[0, 1, 2]} allowMultiple gap={4}>
        <Flex flexDir={'column'} gap={4}>
          <N25_11_13 />
          <N25_11_12 />
          <N25_11_11 />
          <N25_11_06 />
          <N25_11_05 />
          <N25_11_04 />
          <N25_10_28 />
          <N25_10_24 />
          <N25_10_21 />
          <N25_10_16 />
          <N25_10_14 />
          <N25_10_13 />
          <N25_10_10 />
          <N25_10_08 />
          <N25_10_03 />
          <N25_10_02 />
          <N25_09_30 />
          <N25_09_29 />
          <N25_09_16 />
          <N25_09_15 />
        </Flex>
      </Accordion>
    </Flex>
  )
}
